import { DecimalField } from '@ff-it/form';
import { Table, Tbody, Td, Th, Thead, Tr } from '@ff-it/ui';
import { months } from 'options';
import { ReactElement, ReactNode } from 'react';

const monthOptions = months.map((label, idx) => ({ value: idx + 1, label }));

type MonthFactorsProps = {
  name: string;
  label: ReactNode;
};

export function MonthFactors({ name, label }: MonthFactorsProps): ReactElement {
  return (
    <Table mb="3" size="xs" textSize="sm" bordered>
      <Thead>
        <Tr>
          <Th>Month</Th>
          <Th style={{ width: '120px' }} className="text-right">
            {label}
          </Th>
        </Tr>
      </Thead>
      <Tbody>
        {monthOptions.map(({ value, label }) => (
          <Tr key={value}>
            <Td>{label}</Td>
            <Td>
              <DecimalField precision={2} name={`${name}._${value}`} size="sm" className="mb-0 text-right" />
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
}
